<template>
    <div>
        <v-autocomplete v-if="componentEnabled"
                        ref="reference"
                        :aria-label="placeholder"
                        :attach="$refs.anchor"
                        :class="{'some-selections': anySelections}"
                        :clearable="anySelections"
                        :dense="dense"
                        :flat="flat"
                        :items="itemsWithDisabledItems"
                        :menu-props="{
                            transition: 'slide-y-transition',
                            absolute: true,
                            minWidth: 'max-content',
                            maxHeight: 'max(226px, 50vh)',
                            closeOnClick: true,
                            closeOnContentClick: true
                        }"
                        :multiple="multiple"
                        :outlined="outlined"
                        :placeholder="placeholder"
                        :prepend-inner-icon="prependInnerIcon"
                        :search-input.sync="searchInput"
                        :solo="solo"
                        :value="innerValue"
                        clear-icon="far fa-xmark"
                        deletable-chips
                        hide-details
                        :item-text="itemText"
                        item-value="value"
                        style="font-weight: normal"
                        v-bind="$attrs"
                        @input="onAutocompleteInput"
                        v-on="$listeners"
                        @keydown.enter="addUserEnteredItemToSelection">
            <template #selection="data">
                <!--                <pre>data: {{ JSON.stringify(data.item, null, 2) }}</pre>-->
                <v-chip :disabled="data.item.disabled"
                        :input-value="data.selected"
                        close
                        close-icon="fas fa-circle-xmark"
                        small
                        v-bind="data.attrs"
                        @click:close="removeValueFromSelection(data.item.value)">
                    <table-autocomplete-tag v-if="superTags"
                                            :value="data.item.value" />
                    <template v-else>{{ data.item[itemText] }}</template>
                </v-chip>
            </template>
            <template #item="data">
                <!--            <v-list-item v-bind="data.attrs"
                                         v-on="data.on">&lt;!&ndash;v-if="typeof data.item !== 'object'"&ndash;&gt;
                                <v-list-item-content>-->
                <v-list-item-content>
                    <table-autocomplete-tag v-if="superTags"
                                            :value="data.item[itemText]" />
                    <template v-else>{{ data.item[itemText] }}</template>
                </v-list-item-content>
                <v-list-item-action v-if="data.item.userEntered">
                    <v-btn icon
                           @click.stop="removeUserEnteredItem(data.item.value)">
                        <v-icon v-html="'far fa-xmark'" />
                    </v-btn>
                </v-list-item-action>
                <!--                </v-list-item-content>
                            </v-list-item>-->
                <!--            <template v-else>
                                <v-list-item-avatar>
                                    <img :src="data.item.avatar">
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                    <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                                </v-list-item-content>
                            </template>-->
            </template>

            <template #no-data>
                <filter-empty-message />
            </template>

        </v-autocomplete>
        <!--    :dense="dense"
        :solo-inverted="soloInverted"-->

        <portal>
            <div ref="anchor" :class="portalAnchorClass" />
        </portal>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import TableAutocompleteTag from './table-autocomplete-tag.vue'
import { delay } from '../../../../utility.js'

import Template from '../../elements/template.vue'
import { Portal } from '@linusborg/vue-simple-portal'

import popperPositionedVuetifyDropdownMixin from '../../../../mixins/popperPositionedVuetifyDropdownMixin.js'
import FilterEmptyMessage from './filter-empty-message.vue';
import { arraysEqual } from '../../../../../utils/array';

export default defineComponent({
    inheritAttrs: false,
    components: {
        FilterEmptyMessage,
        Template,
        TableAutocompleteTag,
        Portal
    },
    mixins: [popperPositionedVuetifyDropdownMixin],
    props: {
        items: Array,
        itemText: {
            type: String,
            default: 'value'
        },
        value: Array,
        placeholder: String,
        superTags: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: true
        },
        solo: Boolean,
        soloInverted: Boolean,
        flat: Boolean,
        prependInnerIcon: String,
        dense: {
            type: Boolean,
            default: true
        },
        multiple: {
            type: Boolean,
            default: true
        },
        userEnteredItemsEnabled: {
            type: Boolean,
            default: true
        },
        portalAnchorClass: {
            type: String,
            default: 'popper-menu-anchor popper-menu-hide-under-navbar'
        }
    },
    data() {
        return {
            searchInput: '',
            selectedItems: this.value.slice(), // shallow copy
            userEnteredItemsSet: new Set(),
            userEnteredItems: [],
            itemAddedCooldown: false,
            innerValue: this.value

        }
    },
    methods: {
        addUserEnteredItemToSelection() {

            //console.log('addUserEnteredItemToSelection', this.searchInput)
            if (!this.userEnteredItemsEnabled || !this.searchInput || this.itemAddedCooldown) return
            //console.log('itemsLowercaseSet', JSON.stringify(this.itemsLowercaseSet, null, 2))

            const searchInputLowercase = String(this.searchInput).toLowerCase()

            //console.log('searchInputLowercase', typeof searchInputLowercase, searchInputLowercase)

            let selectedItemValue


            if (this.itemsLowercaseSet.has(searchInputLowercase) && this.selectedItemsLowercaseSet.has(searchInputLowercase)) {
                selectedItemValue = this.searchInput
            } else if (this.itemsLowercaseSet.has(`§${this.searchInput.toLowerCase()}`)) {
                selectedItemValue = `§${searchInputLowercase}` // TODO - get name of supertag from somewhere that has original case preserved
            } else {
                //console.log('custom user entered item')

                let inputAlreadyInUserEnteredItems = false

                for (const userEnteredItem of this.userEnteredItemsSet.values()) {
                    if (userEnteredItem.toLowerCase() == searchInputLowercase) {
                        inputAlreadyInUserEnteredItems = true
                        break
                    }
                }

                if (!inputAlreadyInUserEnteredItems) {
                    this.userEnteredItemsSet.add(this.searchInput)
                    //console.log('this.userEnteredItemsSet', this.userEnteredItemsSet)
                    this.userEnteredItems = Array.from(this.userEnteredItemsSet)
                }

                selectedItemValue = this.searchInput
            }

            //console.log('selectedItemValue', selectedItemValue)

            this.searchInput = null

            if (!selectedItemValue) return

            this.selectedItemsLowercaseSet.add(selectedItemValue.toLowerCase())

            //console.log('selectedItemsLowercaseSet', this.selectedItemsLowercaseSet.toString())
            if (this.selectedItemsLowercaseSet.size > this.selectedItems.length) {
                this.selectedItems.push(selectedItemValue)
            }

            this.startItemAddedCooldown()

        },
        removeValueFromSelection(value) {
            //console.log('removing value from selection', value, JSON.stringify(this.selectedItems, null, 2))
            const index = this.selectedItems.findIndex(selectedItem => selectedItem === value)
            if (index >= 0) this.selectedItems.splice(index, 1)
            return index
        },
        removeUserEnteredItem(value) {
            this.removeValueFromSelection(value)
            this.userEnteredItemsSet.delete(value)
            this.userEnteredItems = Array.from(this.userEnteredItemsSet)
            this.searchInput = null
        },
        async onAutocompleteInput(newSelection) {
            //console.log('onAutocompleteInput', newSelection)
            // Hack required to not add two items to selection in the following case:
            // If text input is entered partially (ex. 'uni'), and a menu item is selected
            // with up/down arrows (ex. 'University Course 1'); when the enter button is pressed,
            // the keyboard.enter event is triggered first and the partially entered text gets added
            // to custom search tags, but also this onInput function gets triggered with both the
            // partially entered text and the selected menu item (ex. ['uni', 'University Course 1']).
            // This is Vuetify's fault, they automatically add the selected menu item to selection when
            // enter is pressed, no way to disable this behaviour. Even though the second item is not
            // emitted (so this.value is ['uni']), both 1 are still shown in the input selection
            // area as chips. The Vuetify Autocomplete component has an internal state and adds extra
            // items to their value, even though we are passing the value prop.
            // This hack is required to reset the passed value of v-autocomplete and display only the
            // actual value that should be displayed if they didn't have internal state.
            if (this.itemAddedCooldown) {
                this.innerValue = []
                await this.$nextTick()
                this.innerValue = this.value

                return
            }

            this.startItemAddedCooldown()

            //console.log('newSelection', newSelection)
            this.selectedItems = newSelection
        },
        async startItemAddedCooldown() {
            this.itemAddedCooldown = true
            await delay(2)
            this.itemAddedCooldown = false
        }

    },
    computed: {
        itemsLowercaseSet() {
            return new Set(this.items.filter(({ value }) => value).map(({ value }) => String(value).toLowerCase()))
        },
        selectedItemsLowercaseSet() {
            return new Set(this.selectedItems.map(item => String(item).toLowerCase()))
        },
        anySelections() {
            return this.selectedItems.length > 0
        },
        disabledItems() {
            const filteredItems = this.items ? this.items.filter(item => !item.header && !item.divider) : []


            //console.log('disabledItems', 'innerValue', this.innerValue, 'filteredItems', filteredItems)
            // If there are more entries in `value` than there are in `items`, we have to add
            // disabled entries to `items` to show these extra entries that are present in `value`.
            // The missing entries were filtered out by `tableMixin.js -> filteredItemsWithUserEntered`
            // when other filters were applied.

            const returnValue = []

            for (const entry of this.innerValue) {

                const entryInFilteredItems = filteredItems.findIndex(filteredItem => filteredItem.value === entry) >= 0

                if (entryInFilteredItems) {
                    continue
                }

                //const filteredItemStartsWithEntry = filteredItems.findIndex(filteredItem => filteredItem.value.startsWith(entry)) >= 0

                //if (filteredItemStartsWithEntry) {
                returnValue.push({ value: entry, disabled: true })
                //}
            }

            /*if (this.innerValue.length > filteredItems.length) {
                return this.innerValue.map(innerEntry => ({ value: innerEntry, disabled: true }))
            } else {
                return []
            }*/

            return returnValue
        },
        itemsWithDisabledItems() {
            return Array.isArray(this.items) ? this.items.concat(this.disabledItems) : this.disabledItems
        }
    },
    watch: {
        async selectedItems(val) {
            //console.log(`${this.placeholder.replace('Filter ', '')} selectedItems`, val)
            this.$emit('input', val)
            // Await two nextTicks, one to await innerValue to be set to an empty array,
            // and one for innerValue to be set back to this.value.
            // Part of a hack explained above
            await this.$nextTick()
            await this.$nextTick()
            // Update the position of the popup menu, since items were added to selection and
            // content probably reflowed.
            if (this.popperInstance) this.popperInstance.update()
        },
        userEnteredItems(val) {
            //console.log(`${this.placeholder.replace('Filter ', '')} userEnteredItems`, val)
            this.$emit('update:userEnteredItems', val)
        },
        value(val) {
            //console.log(`${this.placeholder.replace('Filter ', '')} value`, val)
            this.innerValue = val
            if (!arraysEqual(this.selectedItems, val)) {
                this.selectedItems = val.slice();
            }
        }
        //items(val) {
        //    console.log(`${this.placeholder.replace('Filter ', '')} items`, val)
        //}
    }
})
</script>
